import { useMemo } from "react";

import { translate } from "app/filters/i18nFilter";
import { SIBreadcrumbs } from "app/pages/sales-intelligence/common-components/SIBreadcrumbs/SIBreadcrumbs";
import {
    BREADCRUMB_INTEGRATIONS,
    BREADCRUMB_MANAGE_INTEGRATION,
} from "app/pages/sales-intelligence/common-components/export-table/translations";
import { MANAGEMENT_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import { MANAGE_INTEGRATION_ROUTE } from "app/pages/sales-intelligence/constants/sl_routes";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";
import { proNavigator } from "single-spa/react-app/ProNavigator";

type Props = {
    integrationName: Integration;
};

const EnrichmentLogsBreadcrumbs = ({ integrationName }: Props) => {
    const breadcrumbs = useMemo(
        () => [
            {
                state: MANAGEMENT_ROUTE,
                title: translate(BREADCRUMB_INTEGRATIONS),
            },
            {
                state: MANAGE_INTEGRATION_ROUTE[integrationName],
                title: translate(BREADCRUMB_MANAGE_INTEGRATION[integrationName]),
            },
            {
                state: "",
                title: translate("si.crm-enrichment.logs.breadcrumb"),
            },
        ],
        [integrationName],
    );

    const handleBreadcrumbClick = ({ state }: { state: string }): void => {
        if (state) {
            void proNavigator.go(state);
        }
    };

    return (
        <SIBreadcrumbs
            list={breadcrumbs}
            onClick={handleBreadcrumbClick}
            dataAutomation="enrichment-logs-breadcrumbs"
        />
    );
};

export default EnrichmentLogsBreadcrumbs;
